import React, { PureComponent } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H4 } from '../../../components/common/text';
import { emptyError } from '../../../components/common/validation/validation-utils';
import { PALETTE } from '../../../constants';
import { FormGroup, TextInput, Message, Label } from '@dbk/ui-forms';
import commonStyle from '../../../screens/user/login/login.common.style';
import Button from '@dbk/ui-buttons';
import styles from './reset-code.styles';
import Modal from '@dbk/ui-modal';
import WizardSteps from '@dbk/ui-wizard-steps';

class ResetCode extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      resetCode: '',
      resetCodeEmpty: false,
      showResendResetCodePrompt: false,
    };

    this.saveResetCode = this.saveResetCode.bind(this);
    this.sendResetCode = this.sendResetCode.bind(this);
    this.showResendResetCodePrompt = this.showResendResetCodePrompt.bind(this);
    this.hideResendResetCodePrompt = this.hideResendResetCodePrompt.bind(this);
    this.renderResetCodePage = this.renderResetCodePage.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { auth: { authHeader } } = this.props;
    if (prevProps.auth.authHeader !== authHeader) {
      this.closeModal();
    }
  }

  saveResetCode(e) {
    const value = e.target.value;
    const newValue = value.replace(/^\s+|\s+$/g, '');
    this.setState({ resetCode: newValue });
  }

  validate() {
    const { resetCode } = this.state;

    const isResetCodeEmpty = emptyError(resetCode, false);
    const valid = !isResetCodeEmpty;

    this.setState({
      resetCode,
      resetCodeEmpty: isResetCodeEmpty,
    });

    return valid;
  }

  sendResetCode() {
    const { resetCode } = this.state;
    const { resetcode: { sendResetCode } } = this.props;

    if (this.validate()) {
      sendResetCode(resetCode);
    }
  }

  showResendResetCodePrompt() {
    this.props.resetcode.resendResetCode();
    this.setState({ showResendResetCodePrompt: true });
  }

  hideResendResetCodePrompt() {
    this.setState({ showResendResetCodePrompt: false });
  }

  closeModal() {
    this.props.fnCloseModal();
  }


  renderResetCodePage() {
    const {
      i18n: { messages },
      resetcode: {
        verifyingResetCode,
        wrongResetCodeAttemptCount,
        attemptCountHasExceeded,
      },
    } = this.props;
    const { resetCode, resetCodeEmpty, showResendResetCodePrompt } = this.state;
    const errorText = attemptCountHasExceeded ?
      messages['app.reset.resetCode.maxAttempt']
      :
      messages['app.reset.resetCode.invalidCode'];

    const nativeStyle = commonStyle;
    const formGroupMargin = !resetCodeEmpty ?
      nativeStyle.formGroup : nativeStyle.formGroupErrorMargin;
    return (

          <View style={styles.content}>
           <WizardSteps useEqualSpacing steps={[
              { label: messages['app.reset.breadcrumbs.requestCode'] },
              { label: messages['app.reset.breadcrumbs.enterCode'] },
              { label: messages['app.reset.breadcrumbs.resetNewPassword'] },
            ]}
            currentStepIndex={1}
          />
            <div className="margin-10 margin-top-20">
              <H4 className="text-center"> {messages['app.reset.resetCode.confirmation']}</H4>
            </div>

            <View style={styles.inputFields}>
              <div className="pad-top-30 pad-bottom-30">
                <FormGroup style={formGroupMargin}>
                  <Label style={StyleSheet.flatten(nativeStyle.labelStyle)}>{messages['app.reset.resetCode.title']}</Label>
                  <View className='form__input-wrapper' style={StyleSheet.flatten(nativeStyle.inputWrapper)}>
                    <TextInput
                      style={StyleSheet.flatten(nativeStyle.input)}
                      textID="input-reset-code"
                      name="resetCode"
                      value={resetCode}
                      placeholder={messages['app.reset.resetCode.resetCodeText']}
                      type="password"
                      secureTextEntry
                      onChange={this.saveResetCode}
                      keyboardType="numeric"
                      autoCorrect={false}
                      zIndex={-1}
                    />
                  </View>
                  {resetCodeEmpty && (
                    <Message style={StyleSheet.flatten(nativeStyle.userError)} type="error">
                      {messages['app.reset.resetCode.codeError']}
                    </Message>
                  )}
                </FormGroup>
                <View style={styles.attemptCount}>
                  <Text>
                    {messages['app.auth.vasco.authentication.attemptMsg1']} {''}
                    {wrongResetCodeAttemptCount.toString()}
                  </Text>
                  {wrongResetCodeAttemptCount !== 0 &&
                    <Text style={styles.errorTextColor} >{errorText}</Text>
                  }
                </View>
                {/* <View style={styles.wrongUserPassword}>
                  <Text>
                    {wrongUserPassword !== 0 &&
                      <Text style={styles.errorTextColor} >{wrongUserPassword}</Text>
                    }
                   </Text>
                 </View> */}
              </div>
              {verifyingResetCode === false &&
                <View className="text-center">
                  <Button
                    fullWidth
                    size='large'
                    loading={verifyingResetCode}
                    onPress={this.sendResetCode}
                    style={styles.submitButton}
                    >
                    {messages['app.rating.submit']}
                  </Button>
                  <div className="pad-top-30">
                    <span className="inline-link" onClick={this.showResendResetCodePrompt}>
                      {messages['app.reset.resetCode.resendCode']}
                    </span>
                  </div>
                </View>
              }
              {verifyingResetCode === true &&
                <ActivityIndicator
                  animating
                  color={PALETTE.primaryText}
                  size="large"
                  className="pad-top-70"
                />
              }
              {showResendResetCodePrompt &&
                <Modal
                  visible={showResendResetCodePrompt}
                  isActive={showResendResetCodePrompt}
                  onClose={this.hideResendResetCodePrompt}
                  header={
                    <Text style={{ color: 'white', textAlign: 'center' }}>
                      {messages['app.rmcallback.reqSub']}
                    </Text>
                }
                content={
                  <Text style={{ color: 'white', textAlign: 'center' }}>
                    {messages['app.reset.resetCode.emailSent']}
                  </Text>
                }
              />
              }
            </View>
          </View>
    );
  }

  render() {
    return (
      <View style={styles.mainWrapper}>
        {this.renderResetCodePage()}
      </View>
    );
  }
}


export default createContainer({
  $queries: {
    rsaChangePage: { $call: 'rsa.changePage' },
    i18n: {
      messages: true,
    },
    resetcode: {
      sendResetCode: { $call: 'verifyResetCode' },
      verifyingResetCode: true,
      resendResetCode: { $call: 'resendResetCode' },
      wrongResetCodeAttemptCount: true,
      attemptCountHasExceeded: true,
      errorText: true,
      wrongUserPassword: true,
    },
    auth: {
      authHeader: true,
    },
  },
},
)(ResetCode);
